import { ReactNode } from "react"

import {
  DndContext,
  DragEndEvent,
  DragStartEvent,
  PointerSensor,
  closestCenter,
  useSensor,
  useSensors,
} from "@dnd-kit/core"
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable"

export type SortableContainerProps = {
  children: ReactNode
  keys: string[]
  onDragStart: (event: DragStartEvent) => void
  onDragEnd: (event: DragEndEvent) => void
  disabled?: boolean
}

class MyPointerSensor extends PointerSensor {
  static activators = [
    {
      eventName: "onPointerDown" as const,
      handler: ({ nativeEvent }: { nativeEvent: Event }) => {
        const elm = nativeEvent.target as HTMLDivElement
        const shouldFire = elm.closest("[table-move-row]")

        if (!shouldFire) {
          return false
        }

        return true
      },
    },
  ]
}

export function SortableContainer(props: SortableContainerProps) {
  const { keys, children, onDragStart, onDragEnd } = props

  const sensors = useSensors(
    useSensor(MyPointerSensor, {
      activationConstraint: { delay: 100, tolerance: 10 },
    }),
  )

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
    >
      <SortableContext items={keys} strategy={verticalListSortingStrategy}>
        {children}
      </SortableContext>
    </DndContext>
  )
}
